import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'
import { insuranceCases } from '@services/api'
import { users } from '@services/api'
import { StoreExt } from '@utils/reactExt'

export class clientsStore extends StoreExt {
    @observable list = []
    @observable loading = false
    @observable errors = null
    @observable searchParams = {}
    @observable paging = {
        page: 1,
        perPage: 10,
        total: 0,
        lastPage: 0
    }

    @action
    clientsByInsuranceCase = async params => {
        this.resetErrors()
        this.loading = true
        const searchParams = { ...this.searchParams, ...params }
        const { list, total, page } = (await insuranceCases.getClientsByCase({ ...searchParams, ...this.paging })).data
        runInAction(() => {
            this.list = list
            this.loading = false
            this.paging.page = page
            this.paging.total = total
            this.searchParams = { ...searchParams }
        })
    }

    @action
    updateInsuranceCase = user_id => {
        this.loading = true
        users
            .updateHarbCases({ user_id })
            .then(res => {
                runInAction(() => {
                    this.loading = false
                    this.errors = null
                })
                this.clientsByInsuranceCase({})
            })
            .catch(e => {
                runInAction(() => {
                    this.loading = false
                    this.errors = `קיימת שגיאה בעדכון התיק של לקוח ${user_id}`
                })
            })
    }
    @action
    updatePhone = (oldPhone, newPhone) => {
        this.loading = true
        users
            .updatePhone({oldPhone, newPhone  })
            .then(res => {
                runInAction(() => {
                    this.loading = false
                    this.errors = null
                })

            })
            .catch(e => {
                runInAction(() => {
                    this.loading = false
                    this.errors = `קיימת שגיאה     `
                })
                alert('אירעה שגיאה. המספר לא עודכן')
            })
    }

    @action
    changePage = page => {
        this.paging.page = page
    }

    @action
    resetErrors = () => {
        this.errors = null
    }

    @action
    resetSearchParams = () => {
        this.searchParams = {}
    }
}

export default remotedev(new clientsStore())
